export const isDevelopment = process.env.NODE_ENV === "development";

export const API_ALI_URI = "/api/aliyun";
export const API_SIT_URL = "/api/dscloud-account-center";
